import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import type { SmartRoutingConfigurationsResponseType } from "@/types/smart-routing"

const useSmartRoutingConfigurations = (
  whitelabelUuids: string[]
) => {
  return useQuery({
    queryKey: [
      ENDPOINTS.SMART_ROUTING_CONFIGURATIONS,
      whitelabelUuids,
    ],
    queryFn: async () => {
      const { data } =
        await api.get<SmartRoutingConfigurationsResponseType>(
          ENDPOINTS.SMART_ROUTING_CONFIGURATIONS,
          {
            headers: {
              "x-white-label-uuid":
                whitelabelUuids.join(", "),
            },
          }
        )
      return data
    },
  })
}

export default useSmartRoutingConfigurations
